import { dashboardAxios, buildAuthenticationHeaders } from './global';

const getQuickFlowStatus = credentials =>
    dashboardAxios.get(`/messages-10dlc/api/account/${ credentials.accountId }/quickflow`, {
        ...buildAuthenticationHeaders(credentials)
    });

const submitRegistration = async (credentials, data) =>
    dashboardAxios.post(`/messages-10dlc/api/account/${ credentials.accountId }/quickflow`, data,{
        ...buildAuthenticationHeaders(credentials)
    });

const reSubmitAccountRegistration= async (credentials,data)=>{
    dashboardAxios.post(`/messages-10dlc/api/account/${ credentials.accountId }/quickflow/re-register`, data,{
        ...buildAuthenticationHeaders(credentials)
    });
}

const deleteAccountRegistration = async (credentials) =>
    dashboardAxios.delete(`/messages-10dlc/api/account/${ credentials.accountId }/quickflow`,{
        ...buildAuthenticationHeaders(credentials)
    });

const updateAccountRegistration = async (credentials, data) =>
    dashboardAxios.put(`/messages-10dlc/api/account/${ credentials.accountId }/quickflow`, data,{
        ...buildAuthenticationHeaders(credentials)
    });

const requestResubmitRegistration = async (credentials, data) =>
    dashboardAxios.post(`/messages-10dlc/api/account/${ credentials.accountId }/quickflow/requestResubmit`, data,{
        ...buildAuthenticationHeaders(credentials)
    });

const updateAccountBilling = async (credentials, data) =>
    dashboardAxios.put(`/messages-10dlc/api/account/${ credentials.accountId }/quickflow/updateBilling`, data,{
        ...buildAuthenticationHeaders(credentials)
    });

const updateQuickFlowCampaign = async (credentials, data) =>
    dashboardAxios.put(`/messages-10dlc/api/account/${ credentials.accountId }/quickflow/campaign`, data,{
        ...buildAuthenticationHeaders(credentials)
    });

const createSharedRegistration = async (credentials, data) =>
    dashboardAxios.post(`/messages-10dlc/api/account/${ credentials.accountId }/quickflow/shared`, data,{
        ...buildAuthenticationHeaders(credentials)
    });

const getMainAccountRegistration = credentials =>
    dashboardAxios.get(`/messages-10dlc/api/account/${ credentials.accountId }/quickflow/mainAccount`, {
        ...buildAuthenticationHeaders(credentials)
    });

const requestFullSync = async credentials =>
    dashboardAxios.get(`/messages-10dlc/api/account/${ credentials.accountId }/numbers/fullSync`,{
        ...buildAuthenticationHeaders(credentials)
    });

const uploadFile = async (credentials, formData) =>
  dashboardAxios.post(`/messages-10dlc/api/bulk-sms/requests/upload`, formData, {
    ...buildAuthenticationHeaders(credentials),
    headers: {
      ...buildAuthenticationHeaders(credentials).headers,
      'Content-Type': 'multipart/form-data',
    }
  });

const selectSoleProprietorNumber = async (credentials, phoneNumber) =>
    dashboardAxios.post(`/messages-10dlc/api/account/${credentials.accountId}/sms-number`,
        { "phone_number": phoneNumber },
        {
            ...buildAuthenticationHeaders(credentials)
        }
    );

const cancelAccountRegistration = async (credentials) =>
    dashboardAxios.post(`/messages-10dlc/api/account/${credentials.accountId}/quickflow/registration/cancel`, {}, {
        ...buildAuthenticationHeaders(credentials)
    });
const fetchAndExportNumberPooling=async credentials =>
    dashboardAxios.get(`/messages-10dlc/api/account/${ credentials.accountId }/numberPooling/getNpListData`,{
        ...buildAuthenticationHeaders(credentials)
    });
const deleteSmsRegistration=async credentials => {
    await dashboardAxios.delete(`/messages-10dlc/api/account/${credentials.accountId}/admin`, {
        ...buildAuthenticationHeaders(credentials)
    });
}
const getSinchApprovalPending = async (credentials) =>
    dashboardAxios.get(`/messages-10dlc/api/account/${credentials.accountId}/sinch-approval-pending`, {
        ...buildAuthenticationHeaders(credentials)
    });

const submitBulkSmsCampaign = async (credentials, data) =>
  dashboardAxios.post(
    `/messages-10dlc/api/account/${credentials.accountId}/bulk-sms/campaign`,
    data,
    { ...buildAuthenticationHeaders(credentials) }
  );

const getBulkSmsCampaign = async (credentials) =>
  dashboardAxios.get(
    `/messages-10dlc/api/account/${credentials.accountId}/bulk-sms/campaign`,
    { ...buildAuthenticationHeaders(credentials) }
  );

const getBulkSmsCampaignNumbers = async (credentials) =>
  dashboardAxios.get(
    `/messages-10dlc/api/account/${credentials.accountId}/bulk-sms/campaign/numbers`,
    { ...buildAuthenticationHeaders(credentials) }
  );

const updateBulkSmsCampaignNumbers = async (credentials, phoneNumbers) =>
  dashboardAxios.put(
    `/messages-10dlc/api/account/${credentials.accountId}/bulk-sms/campaign/numbers`,
    phoneNumbers,
    { ...buildAuthenticationHeaders(credentials) }
  );

const editBulkSmsCampaign = async (credentials, data) =>
    dashboardAxios.patch(`/messages-10dlc/api/account/${ credentials.accountId }/bulk-sms/campaign`, data, {
        ...buildAuthenticationHeaders(credentials)
    });

const cancelBulkSmsCampaign = async (credentials) =>
    dashboardAxios.post(`/messages-10dlc/api/account/${credentials.accountId}/bulk-sms/campaign/cancel`, {}, {
        ...buildAuthenticationHeaders(credentials)
    });



const enableSinchNumberPool = async (credentials) =>
    dashboardAxios.put(`/messages-10dlc/api/account/${credentials.accountId}/numberPooling/sinchPoolEnable`, {}, {
        ...buildAuthenticationHeaders(credentials)
    });

export {
    getQuickFlowStatus,
    submitRegistration,
    deleteAccountRegistration,
    updateAccountRegistration,
    requestResubmitRegistration,
    updateAccountBilling,
    updateQuickFlowCampaign,
    getMainAccountRegistration,
    requestFullSync,
    cancelAccountRegistration,
    createSharedRegistration,
    reSubmitAccountRegistration,
    uploadFile,
    editBulkSmsCampaign,
    cancelBulkSmsCampaign,
    fetchAndExportNumberPooling,
    selectSoleProprietorNumber,
    deleteSmsRegistration,
    submitBulkSmsCampaign,
    getBulkSmsCampaignNumbers,
    getBulkSmsCampaign,
    updateBulkSmsCampaignNumbers,
    getSinchApprovalPending,
    enableSinchNumberPool
};
